<template>
  <div class="q-wrap">
    <div class="q-row">
      <label class="q-label">Texto de la pregunta</label>
      <input class="q-input" :class="{ 'q-input--error': question.error }" type="text"
        placeholder="Escribe la pregunta aquí..." v-model="question.texto" />
      <p v-if="question.error" class="q-error-msg">Ingrese la pregunta.</p>
    </div>

    <div class="q-row">
      <label class="q-label">Descripción <span>(opcional)</span></label>
      <textarea class="q-input" type="text" placeholder="Describe lo que se espera en la respuesta..." v-model="question.descripcion" ></textarea>
    </div>

    <div class="q-row">
      <label class="q-label">Nota <span>(opcional)</span></label>
      <input class="q-input" type="text" placeholder="Escribe una nota corta o definición..." v-model="question.nota_para_registrante" />
    </div>

    <div class="q-row">
      <label class="q-check-row ml-auto">
        <input type="checkbox" v-model="question.obligatoria" />
        <span>Obligatoria</span>
      </label>
    </div>

    <div class="q-date-preview">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/></svg>
      El registrante vera un selector de fecha
    </div>
  </div>
</template>

<script>
export default {
  name: "date-question",
  data() { return { lastId: 1 }; },
  mounted() { if (this.question.subpregunta) this.lastId = this.question.subpregunta.length + 1; },
  methods: {
    remove() { this.$emit("click"); },
    validateQuestion() { return this.validateEmptyQuestion(); },
    validateEmptyQuestion() {
      if (this.question.texto === "") { this.question.error = true; return false; }
      this.question.error = false; return true;
    },
  },
  props: { question: { required: true } },
};
</script>

<style scoped>
.q-wrap { display: flex; flex-direction: column; gap: 12px; font-size: 0.82rem; }
.q-row { display: flex; flex-direction: column; gap: 4px; }
.q-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #64748b; }
.q-input { width: 100%; padding: 6px 10px; border: 1px solid #cbd5e1; border-radius: 7px; background: #f8fafc; color: #334155; font-size: 0.82rem; transition: border-color 0.15s; outline: none; box-sizing: border-box; }
.q-input:focus { border-color: #059669; box-shadow: 0 0 0 3px rgba(5,150,105,0.12); background: #fff; }
.q-input--error { border-color: #f87171 !important; }
.q-error-msg { font-size: 0.7rem; color: #ef4444; margin: 0; }
.q-check-row { display: flex; align-items: center; gap: 6px; }
.q-check-row input[type=checkbox] { width: 14px; height: 14px; accent-color: #059669; cursor: pointer; }
.q-check-row span { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: #475569; }
.q-date-preview { display: flex; align-items: center; gap: 6px; font-size: 0.7rem; color: #94a3b8; background: #f0fdf4; border: 1px dashed #86efac; border-radius: 6px; padding: 6px 10px; font-style: italic; }
.q-date-preview svg { width: 14px; height: 14px; color: #059669; flex-shrink: 0; }
</style>
